import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=e02f6938&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=e02f6938&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports